import { ApiCall } from '@lcms/api-definition';
import endpoints from './api-endpoint-definition.json';

export type FeaturedTopicsResponse = string[];

const definition = new ApiCall<FeaturedTopicsResponse>().get('featuredTopics', { route: endpoints.featuredTopics })
export default definition;